import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex, IconButton, Text } from 'onefaceui-react-components';
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';

import { useEventLog } from 'react/queries/EventLog';
import { useStopList } from 'react/queries/StopList';
import { getResourceTo } from 'react/utils/utils';
import { actionCreators } from 'react/api/actions/monitor';
import closeIcon from 'static/images/sidebar/close.svg';
import { Container } from './RoutePanel.styles';

import RouteInfo from './RouteInfo/index';
import RouteEvents from './RouteEvents';
import StopList from './StopList';

function RoutePanel() {
  const dispath = useDispatch();
  const isOpen = useSelector((state) => state.routeMonitor.routePanel.isOpen);
  const route = useSelector((state) => state.routeMonitor.routePanel.route);
  const routeOnMap = useSelector(
    (state) => state.routeMonitor.routesOnMap.find((item) => item.id === route?.id)
  );
  const title = useSelector((state) => state.routeMonitor.routePanel.title);
  const { data: dataEvents = [], refetch: refetchEvents } = useEventLog(route?.id);
  const { refetch: refetchStops } = useStopList(route?.id);

  function closeRoutePanel() {
    dispath(actionCreators.closeRoutePanel());
  }

  useEffect(() => {
    if (route?.id) {
      refetchEvents();
      refetchStops();
    }
  }, [route?.id]);

  if (!isOpen || !route) {
    return null;
  }

  return (
    <Container
      flexDirection="column"
      className="route-panel"
      isOpen={isOpen}
      data-testid="route-panel"
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        className="header"
      >
        <Flex alignItems="center" gap={8} className="route-title">
          <Flex shouldShow={!!routeOnMap} className="tag-color" style={{ background: routeOnMap?.color }} />
          <Text type="primary" weight="bold" data-testid="route-title">
            {title}
          </Text>
        </Flex>
        <IconButton
          size="sm"
          onClick={() => closeRoutePanel()}
          data-testid="close-btn"
        >
          <img src={closeIcon} alt="Close Icon" />
        </IconButton>
      </Flex>
      <div className="react-tabs-wrapper">
        <Tabs defaultIndex={0}>
          <TabList>
            <Tab>{getResourceTo('routePanel.routeInfo')}</Tab>
            <Tab>
              <Flex alignItems="center" gap={8}>
                {getResourceTo('routePanel.routeEvents')}
                {!!dataEvents.length && (
                  <Flex
                    alignItems="center"
                    justifyContent="center"
                    className="tabBadge"
                    data-testid="event-badge"
                  >
                    <Text type="light" size="xss">
                      {dataEvents.length}
                    </Text>
                  </Flex>
                )}
              </Flex>
            </Tab>
            <Tab>{getResourceTo('RouteMonitor.filter.stopList')}</Tab>

          </TabList>
          <TabPanel>
            <RouteInfo routeId={route.id} routeView={route} />
          </TabPanel>
          <TabPanel className="events-tab">
            <RouteEvents routeId={route.id} />
          </TabPanel>
          <TabPanel className="stop-list-tab">
            <StopList routeId={route.id} />
          </TabPanel>
        </Tabs>
      </div>
    </Container>
  );
}

export default RoutePanel;
